export class CommunicationCommand {
  action: string;
  message?: any;
  component?: string;
  constructor(action: 'open' | 'close' | 'edit' | 'view', message: any, component) {
    this.action = action;
    this.message = message;
    this.component = component;
  }
}
